export function createNode(type_, props_ = {}, children_ = []) {
  return {
    type: type_,
    props: props_,
    children: children_,
  };
}

function isEscaped(source_, index_) {
  let backslashCount = 0;
  let cursor = index_ - 1;
  while (cursor >= 0 && source_[cursor] === "\\") {
    backslashCount += 1;
    cursor -= 1;
  }
  return backslashCount % 2 === 1;
}

export function findClosingSequence(source_, fromIndex_, marker_) {
  let searchIndex = source_.indexOf(marker_, fromIndex_);
  while (searchIndex !== -1) {
    if (!isEscaped(source_, searchIndex)) {
      return searchIndex;
    }
    searchIndex = source_.indexOf(marker_, searchIndex + marker_.length);
  }
  return -1;
}

export function findClosingBracket(source_, fromIndex_, openChar_, closeChar_) {
  let depth = 0;
  for (let i = fromIndex_; i < source_.length; i += 1) {
    const currentChar = source_[i];
    if (currentChar === openChar_ && !isEscaped(source_, i)) {
      depth += 1;
      continue;
    }
    if (currentChar === closeChar_ && !isEscaped(source_, i)) {
      if (depth === 0) {
        return i;
      }
      depth -= 1;
    }
  }
  return -1;
}

export function normaliseCodeSpan(value_) {
  // Normalize inline code whitespace
  if (!value_) {
    return "";
  }
  let result = value_;
  if (result.startsWith(" ") && result.endsWith(" ") && result.trim() !== "") {
    result = result.slice(1, -1);
  }
  return result.replace(/\s+/g, (match_) =>
    match_.includes("\n") ? " " : match_
  );
}

export function parseLinkDestination(raw_ = "") {
  let working = raw_.trim();
  let classes = "";
  const classMatch = working.match(/\{([^}]+)\}\s*$/);
  if (classMatch) {
    classes = classMatch[1].trim();
    working = working.slice(0, classMatch.index).trim();
  }
  let title = "";
  const titleMatch = working.match(/(["'])(.+)\1\s*$/);
  if (titleMatch) {
    title = titleMatch[2].trim();
    working = working.slice(0, titleMatch.index).trim();
  }
  const href = working;
  return { href: href ?? "", title, classes };
}

export function parseTrailingClassAnnotation(source_ = "", fromIndex_ = 0) {
  if (typeof source_ !== "string" || !Number.isFinite(fromIndex_)) {
    return { classes: "", nextIndex: fromIndex_ };
  }
  let cursor = Math.max(0, Math.trunc(fromIndex_));
  while (
    cursor < source_.length &&
    (source_[cursor] === " " || source_[cursor] === "\t")
  ) {
    cursor += 1;
  }
  if (source_[cursor] !== "{" || source_[cursor + 1] === "{") {
    return { classes: "", nextIndex: fromIndex_ };
  }
  const closeIndex = findClosingBracket(source_, cursor + 1, "{", "}");
  if (closeIndex === -1) {
    return { classes: "", nextIndex: fromIndex_ };
  }
  const classes = source_.slice(cursor + 1, closeIndex).trim();
  return {
    classes,
    nextIndex: closeIndex + 1,
  };
}
